<template>
  <div class="courseType">
    <div class="check-type">
      <em class="label">课程分类:</em>
      <el-checkbox-group v-model="checkCourse">
        <el-checkbox-button v-model="checkCourse" value="" label="" key="全部" @change="handleDocAllchange">全部
        </el-checkbox-button>
        <el-checkbox-button v-for="(doc,index) in corricuList" :label="doc.consId" :key="doc.consId" @change="handleDocChange">
          {{corricuList[index].showZN}}
        </el-checkbox-button>
      </el-checkbox-group>
    </div>
    <!--学科分类-->
    <div class="check-type">
      <em class="label">学科分类:</em>
      <el-checkbox-group v-model="subjectCourse">
        <div class="allCheck">
          <el-checkbox-button v-model="subjectCourse" value="" label="" key="全部" @change="handleSubAllchange">全部
          </el-checkbox-button>
        </div>
        <div class="rtCheck">
          <el-checkbox-button v-for="(doc,index) in subjectList" :label="doc.consId" :key="doc.consId" @change="handleSubChange">
            {{subjectList[index].showZN}}
          </el-checkbox-button>
          <div class="moreTxt" @click="toggle">
            <span class="iconfont" v-bind:class="{ 'el-icon-minus' : isHide, 'el-icon-plus': isShow}"><i>{{moreTxt}}</i></span>
          </div>
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  export default {
    props: {
      active: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isShow: true,
        isHide: false,
        moreTxt: '更多',
        corricuList: [],
        subjectList: [],
        checkCourse: [''],
        subjectCourse: ['']
      }
    },
    mounted() {
    },
    methods: {
      courseList(){   //课程分类常量列表
        let params = {
          typeId: 'EDU_COURSETYPE'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
             this.corricuList = res.data.model
          } else {
          }
        })
      },
      subjectData(){   //学科分类常量列表
        let params = {
          typeId: 'EDU_SUBJECTTYPE'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.subjectList = res.data.model
          } else {
          }
        })
      },
      handleDocAllchange(val) {   //课程分类切换
        this.checkCourse = val ? [''] : []
      },
      handleDocChange(value) {
        let index = this.checkCourse.indexOf(String(''))
        if (index != -1) {
          this.checkCourse.splice(index, 1)
        }
        if (!value) {
          if (this.checkCourse.length == 0) {
            this.checkCourse = ['']
          }
        }
      },
      handleSubAllchange(val) {   //学科分类切换
        this.subjectCourse = val ? [''] : []
      },
      handleSubChange(value) {
        let index = this.subjectCourse.indexOf(String(''))
        if (index != -1) {
          this.subjectCourse.splice(index, 1)
        }
        if (!value) {
          if (this.subjectCourse.length == 0) {
            this.subjectCourse = ['']
          }
        }
      },
      toggle(){     //更多折叠收起
        this.isHide = !this.isHide
        this.isShow = !this.isShow
        if(this.moreTxt==='更多'){
          this.moreTxt = '收起'
          $('.moreTxt').css({"position":"relative","right":"inherit","display":"inline-block"})
          $('.rtCheck').css({"height":"auto"})
        } else {
          this.moreTxt = '更多'
          $('.moreTxt').css({"position":"absolute","right":"-35px"})
          $('.rtCheck').css({"height":"32px"})
        }
      }
    },
    watch: {
      active(c){
       if(c==='first'||c==='third'||c==='fourth') {
         this.isShow = true
         this.isHide = false
         $('.rtCheck').css({"height":"32px"})
         $('.moreTxt').css({"position":"absolute","right":"-35px"})
         this.moreTxt = '更多'
       }
      },
      checkCourse(c, o){
        this.$emit('checkCourse',c)
      },
      subjectCourse(c, o){
        this.$emit('subjectCourse', c)
      }
    },
    created() {
      this.courseList()
      this.subjectData()
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .check-type
    line-height: 32px
    width: 100%
    color: #000
    .allCheck
      float: left
    .rtCheck
      float: left
      width: calc(100% - 263px)
      position: relative
      height: 32px
      .moreTxt
        width: 73px
        height: 32px
        cursor: pointer
        color: #909090
        position: absolute
        bottom: -7px
        right: -35px
        span
          font-size: 14px !important
          i
            font-size: 14px
    em
      font-style: normal
      width: 66px
      height: 32px
      margin-right: 6px
      color: $color-text
      float: left
    > li
      float: left
      label
        cursor: pointer;
        padding: 0 6px
      span
        color:#9d9ea3
</style>



// WEBPACK FOOTER //
// courseType.vue?758805b6